var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBhiLogoHalfKnockout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 357.83 356.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#fff;}.cls-3{fill:#ccdf73;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "122.52 135.9 36.12 135.9 36.12 319.7 219.92 319.7 219.92 233.3 122.52 233.3 122.52 135.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "230.92 222.3 317.32 222.3 317.32 38.5 133.52 38.5 133.52 124.9 230.92 124.9 230.92 222.3"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 133.52,
    y: 135.9,
    width: 86.4,
    height: 86.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "219.92 135.9 219.92 222.3 230.92 222.3 230.92 124.9 133.52 124.9 133.52 135.9 219.92 135.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "219.92 319.7 36.12 319.7 36.12 135.9 122.52 135.9 122.52 124.9 25.12 124.9 25.12 330.7 230.92 330.7 230.92 233.3 219.92 233.3 219.92 319.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "328.32 27.5 122.52 27.5 122.52 124.9 133.52 124.9 133.52 38.5 317.32 38.5 317.32 222.3 230.92 222.3 230.92 233.3 328.32 233.3 328.32 27.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "133.52 135.9 122.52 135.9 122.52 233.3 219.92 233.3 219.92 222.3 133.52 222.3 133.52 135.9"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 122.52,
    y: 124.9,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 219.92,
    y: 222.3,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M62.56,152.52h9.18v56.09H62.56Zm4.63,47.37H83.74c3.21,0,5.61-.67,7.17-2a7.06,7.06,0,0,0,2.36-5.65v-.12a9.11,9.11,0,0,0-.93-4.28,6.17,6.17,0,0,0-2.85-2.72,10.84,10.84,0,0,0-4.79-.95H67.19v-8.64H84.7a8.28,8.28,0,0,0,5.83-1.85,6.92,6.92,0,0,0,2-5.36A6.5,6.5,0,0,0,90.41,163q-2.11-1.78-6.25-1.79h-17v-8.72H85.05a20.75,20.75,0,0,1,9.2,1.84,12.63,12.63,0,0,1,5.67,5.22,16.41,16.41,0,0,1,1.91,8.14,12.75,12.75,0,0,1-1.21,5.61A11,11,0,0,1,97,177.56a14.14,14.14,0,0,1-5.81,2.31,13.47,13.47,0,0,1,6.1,2.34,12,12,0,0,1,3.89,4.66,14.6,14.6,0,0,1,1.35,6.35v.11a15.73,15.73,0,0,1-2,8.12,13.31,13.31,0,0,1-5.83,5.31,20.39,20.39,0,0,1-9,1.85H67.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M156.47,152.52h9.22v56.09h-9.22Zm4.9,24h31.9v8.83h-31.9Zm26.38-24H197v56.09h-9.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M277,208.61h-9.41V152.52H277Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBhiLogoHalfKnockout);
export default __webpack_public_path__ + "static/media/BHI Logo_Half_Knockout.b74abf02772457ffceda9ee231c5f6a6.svg";
export { ForwardRef as ReactComponent };